import { Modal } from "bootstrap";

const userLoginOpen = () => {
  if (document.querySelector(".js-login-modal")) {
    const modalEl = document.querySelector(".js-login-modal");

    // eslint-disable-next-line no-undef
    const modal = new Modal(modalEl, {
      backdrop: true,
      keyboard: true,
      focus: true,
    });

    // Open BTN
    document.querySelectorAll(".login-icon").forEach((x) => x.addEventListener("click", () => {
      modal.show();
    }));
  }
};

export default userLoginOpen;
